import _ from "lodash";
import {TopicPreview} from "../../stores/CoursePreviewStore/Types";

export const getLastLesson = chapters => {
  const lastChapter = _.last(chapters) as TopicPreview;
  const lastQuestion = _.last(lastChapter?.questions);

  return lastQuestion;
};
